var exports = {
  "ColorDivider": "ColorDivider__5haUfi",
  "ColorDivider--thick": "ColorDivider--thick__g31wX5",
  "ColorDivider__strip": "ColorDivider__strip__zmBbsK",
  "ColorDivider__block": "ColorDivider__block__keRe99",
  "ColorDivider__duckyTrack": "ColorDivider__duckyTrack__t9JWIg",
  "color-divider-enter": "color-divider-enter__MC_AnY",
  "color-divider-ducky-enter": "color-divider-ducky-enter__78mpvF",
  "color-divider-ducky-fade-in": "color-divider-ducky-fade-in__vP5Miq",
  "ColorDivider__block--blue": "ColorDivider__block--blue__uAeiJ7",
  "ColorDivider__block--blueLight": "ColorDivider__block--blueLight__qdZROG",
  "ColorDivider__block--blueLighter": "ColorDivider__block--blueLighter__u1eB9g",
  "ColorDivider__block--purple": "ColorDivider__block--purple__rqS01r",
  "ColorDivider__block--pink": "ColorDivider__block--pink__RdlGhZ",
  "ColorDivider__block--green": "ColorDivider__block--green__ePc2Qc",
  "ColorDivider__block--greenLight": "ColorDivider__block--greenLight__VWSnyc",
  "ColorDivider__block--greenDark": "ColorDivider__block--greenDark__F0DFv9",
  "ColorDivider__block--borderSubtle": "ColorDivider__block--borderSubtle__39L54m",
  "ColorDivider__block--borderDefault": "ColorDivider__block--borderDefault__iDgBR5",
  "ColorDivider__ducky": "ColorDivider__ducky__r1laJn",
};

__webpack_require__.r(module.exports = exports);
